import { render, staticRenderFns } from "./FormSong.vue?vue&type=template&id=6db4cc27&scoped=true&"
import script from "./FormSong.vue?vue&type=script&lang=js&"
export * from "./FormSong.vue?vue&type=script&lang=js&"
import style0 from "./FormSong.vue?vue&type=style&index=0&id=6db4cc27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db4cc27",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VDatePicker,VMenu,VSpacer,VTextField})
